import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    colors_state_list: [],
};
export var ColorSlice = createSlice({
    name: "colorIcon",
    initialState: initialState,
    reducers: {
        setColorState: function (state, data) {
            state.colors_state_list = data.payload;
        },
    },
});
export var setColorState = ColorSlice.actions.setColorState;
export default ColorSlice.reducer;
